import { BrowserRouter, Route, Routes } from 'react-router-dom'

import PageLayout from '../components/PageLayout'
import TrackingPageLayout from '../components/TrackingPageLayout/TrackingPageLayout'
import LabelTrackingPage from '../LabelTrackingPage/LabelTrackingPage'
import PageNotFound from '../PageNotFound/PageNotFound'
import TrackingPage from '../TrackingPage/TrackingPage'
import routes from './routes.constants'

const Router = () => {
  return (
    <BrowserRouter useTransitions={false}>
      <Routes>
        <Route element={<PageLayout />}>
          <Route path={routes.labelTrackingInfo} element={<LabelTrackingPage />} />
          <Route path={routes.fulfillments} element={<LabelTrackingPage />} />
        </Route>
        <Route element={<TrackingPageLayout />}>
          <Route path={routes.tracking} element={<TrackingPage />} />
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  )
}

export default Router
